export const APP_ENV = {
	ENVIRONMENT: 'PROD'
}
